export const sdksColumns = [{
  dataField: 'logo',
  text: 'Logo',
}, {
  dataField: 'name',
  text: 'SDK Name',
  sortable: true,
  sortBy: 'name',
}, {
  dataField: 'functions',
  text: 'SDK Function',
  sortable: true,
  sortBy: 'functions',
}, {
  dataField: 'apptopia_rank',
  text: 'Apptopia Rank',
  sortable: true,
  sortBy: 'apptopia_rank',
}, {
  dataField: 'total_installs',
  text: 'Total Installs',
}, {
  dataField: 'total_uninstalls',
  text: 'Total Uninstalls',
}];
